import { Tag, TagStatus } from "@magnetic/tag";

import { BaseColumnConfig } from "./baseColumnConfig";

const statusFor = (code: number): TagStatus => {
  if (code >= 400) return "negative";
  if (code >= 300) return "info";
  if (code >= 200) return "positive";
  return "inactive";
};

export class HttpStatusColumn extends BaseColumnConfig<number> {
  compare(a: number = 0, b: number = 0) {
    return a - b;
  }
  render(value: number = 0) {
    return <Tag.Status status={statusFor(value)}>{String(value)}</Tag.Status>;
  }
}
